import 'reflect-metadata';
import type IScimTokenRepository from '../IScimTokenRepository';
import type { ScimTokenDTO, ScimTokenCreateDTO } from '../scimToken.types';
import { injectable } from 'inversify';
import API from '@repositories/Axios';

@injectable()
export class ScimTokenRepository implements IScimTokenRepository {
  async getScimTokens(tenantId: string): Promise<ScimTokenDTO[]> {
    const result = await API.get<ScimTokenDTO[]>(`/api/v1/tenants/${tenantId}/scim-tokens`);
    return result.data;
  }

  async getScimToken(tenantId: string, tokenId: string): Promise<ScimTokenDTO> {
    const result = await API.get<ScimTokenDTO>(`/api/v1/tenants/${tenantId}/scim-tokens/${tokenId}`);
    return result.data;
  }

  async createScimToken(tenantId: string, dto: ScimTokenCreateDTO): Promise<ScimTokenDTO> {
    const result = await API.post<ScimTokenDTO>(`/api/v1/tenants/${tenantId}/scim-tokens`, dto);
    return result.data;
  }

  async deleteScimToken(tenantId: string, tokenId: string): Promise<void> {
    await API.delete<void>(`/api/v1/tenants/${tenantId}/scim-tokens/${tokenId}`);
  }

  async revokeScimToken(tenantId: string, tokenId: string): Promise<void> {
    await API.put<void>(`/api/v1/tenants/${tenantId}/scim-tokens/${tokenId}/revoke`);
  }

  async activateScimToken(tenantId: string, tokenId: string): Promise<void> {
    await API.put<void>(`/api/v1/tenants/${tenantId}/scim-tokens/${tokenId}/activate`);
  }
}
